var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 60,
    viewBox: "0 0 74 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2756)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_442_2756",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.9358 0.665039H0.867188V59.6128H72.9358V0.665039Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_442_2756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7629 37.7608L72.9551 37.5879L66.2025 30.8306L62.3604 26.9884C60.7419 25.37 57.9179 25.5765 56.0401 27.4687L62.7974 34.2212L63.9357 35.3642H55.4734C54.5609 30.5616 51.3143 24.03 45.7912 15.8462C40.9886 8.75271 36.3012 3.07117 36.0995 2.83104L34.2985 0.665039L32.4975 2.83104C32.3006 3.07117 27.594 8.75271 22.8057 15.8462C20.628 19.0307 18.6286 22.3336 16.8168 25.7397H10.4197C10.4197 28.3908 12.2687 30.5424 14.5596 30.5424H14.5932V30.5951H19.66L19.684 30.5424H34.2937C34.2937 27.8913 32.4446 25.7397 30.1538 25.7397H22.143C25.8026 19.2945 30.8646 12.3931 34.2937 8.05633C39.5766 14.7512 48.7689 27.5407 50.6947 35.3642H38.3231C38.3231 38.0153 40.1769 40.1669 42.463 40.1669H50.9109C50.4071 44.2271 48.443 47.9654 45.3853 50.6837C42.3275 53.4021 38.385 54.9149 34.2937 54.9399C32.0287 54.9375 29.7881 54.4726 27.7094 53.573C25.6306 52.674 23.7577 51.359 22.2054 49.7098H24.7364C24.7364 47.3084 23.2332 45.349 21.2641 44.9791C21.0439 44.9376 20.8205 44.915 20.5965 44.9119H0.867188C0.867188 47.563 2.72101 49.7146 5.00708 49.7146H16.2789C18.6732 53.4847 22.1877 56.4104 26.3293 58.0818C30.471 59.7531 35.0318 60.0859 39.3722 59.0332C43.7125 57.9809 47.6144 55.5959 50.5305 52.2134C53.4467 48.8304 55.2304 44.6197 55.6319 40.1717H63.9309L62.7926 41.3099L56.0353 48.0336C57.9131 49.9115 60.7371 50.118 62.3556 48.5139L66.1977 44.6718L72.9358 37.9481C72.8734 37.8712 72.811 37.8184 72.7629 37.7608Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1105 35.3682H5.63281C5.63281 38.0192 7.48662 40.1708 9.77268 40.1708H12.952H17.673H29.5309C29.5309 37.5198 27.677 35.3682 25.391 35.3682H17.8844H13.1105Z",
    fill: "#00AEEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.5201,
    height: 59.0727,
    fill: "white",
    transform: "translate(0.875 0.665039)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.b3c244dd59165971b130229b91f74f5a.svg";
export { ForwardRef as ReactComponent };